import {
  Bold,
  CodeInline,
  Color,
  ColorHighlighter,
  Emoji,
  Italic,
  Link,
  Mention,
  SelectionToolbar,
  Strikethrough,
  TypographyInputRules,
  Underline,
} from '@lyearn/lygo-blocks';

export const messageEditorExtensions = [
  Emoji,
  Bold,
  Italic,
  CodeInline,
  Underline,
  Strikethrough,
  Link,
  SelectionToolbar,
  Color,
  Mention,
  TypographyInputRules,
  ColorHighlighter,
];
